<template>
  <v-container
    fluid
    v-bind:style="{
      backgroundImage: 'url(' + site.bg_url + ')',
      backgroundColor: site.color,
    }"
    style="
      height: 100%;
      padding-bottom: 24px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    "
  >
    <div style="position: absolute; right: 10px; top: 10px; z-index: 1">
      <SelectLangauge />
    </div>

    <v-row class="justify-center">
      <v-col cols="12" sm="8" md="8" class="d-flex justify-center pa-0">
        <v-icon
          v-if="!query_campaign_id"
          :style="{
            position: site.logo_url ? 'absolute' : 'relative',
          }"
          style="
            left: 10px;
            top: 10px;
            z-index: 1;
            border-radius: 50%;
            border: 1px solid;
            box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
          "
          color="white"
          large
          @click="redirectHome()"
        >
          mdi-chevron-left-circle
        </v-icon>
        <v-img :src="site.logo_url"></v-img>
      </v-col>
      <v-col cols="12" sm="8" md="8" class="px-0">
        <!-- <v-img :src="template.header_path"></v-img> -->
        <Survey
          v-if="survey"
          :survey="survey"
          style="background-color: transparent; padding-top: 0px"
        />
        <v-checkbox
          v-if="false"
          v-model="terms_of_service"
          :rules="normalRules"
          color="white"
          dark
          style="margin-top: -4%; margin-left: 6%"
        >
          <template v-slot:label>
            <v-btn
              class="white--text text-decoration-underline"
              text
              @click="dialogPDPA = true"
            >
              {{ $t("agreeTermAndCondition") }}
            </v-btn>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <DialogVerifyOtp
      ref="refVerifyOTP"
      v-model="dialogOtp"
      :dialogOtp="dialogOtp"
      :ref_code="ref_code"
      :site="site"
      @close="dialogOtp = false"
      @verifyOtp="checkOTP"
      @sendOtp="sendOtpAgain"
    ></DialogVerifyOtp>

    <v-layout row justify-center>
      <v-dialog v-model="dialogPDPA" persistent max-width="500" scrollable>
        <v-card>
          <v-btn
            fab
            @click="scrollToBottom"
            style="position: absolute; right: 6px; bottom: 10px"
            color="grey darken-2"
            small
            v-if="showScrollIcon"
            class="mx-2"
          >
            <v-icon color="white" size="24">mdi-arrow-down </v-icon>
          </v-btn>

          <v-card-title class="headline">{{
            $t("privacyPolicy")
          }}</v-card-title>

          <v-card-text
            @scroll="handleScroll"
            ref="scrollContainer"
            style="max-height: 90vh; overflow-y: auto"
          >
            <v-col cols="12" class="pa-0">
              <div
                class="ql-editor"
                style="height: fit-content"
                v-html="formatCondition(condition)"
              ></div>
              <div class="d-flex" ref="scrollTarget">
                <v-spacer></v-spacer>
                <v-btn
                  :color="site.color"
                  @click.native="agreeCondition"
                  dark
                  >{{ $t("confirm") }}</v-btn
                >
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import { Model } from "survey-vue";
import "survey-core/defaultV2.min.css";
import axios from "axios";
import { themeJson } from "../../../scss/themeJson.js";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
  formattedForSave,
  getLandingPage,
  transformJsonCustomInputMask,
} from "../../../config/general-function.js";
import DialogVerifyOtp from "@/components/dialogVerifyOtp.vue";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";
import SelectLangauge from "../../../components/selectLangauge.vue";

const customCss = {
  question: {
    content: "question-content",
    titleRequired: "question-title-required",
  },
};

export default {
  inject: ["isAppLoading"],
  components: { Survey, DialogVerifyOtp, SelectLangauge },
  data() {
    return {
      loading: false,
      survey: null,
      terms_of_service: false,
      ref_code: "",
      OTP: "",
      request_id: "",

      dialogOtp: false,
      dialogPDPA: true,

      condition: "",
      disableBtnRegister: true,
      query_campaign_id: null,
      campaign_id: null,
      mission_id: null,
      detailUser: {
        name: null,
        surname: null,
        phone: null,
        birth_date: null,
        gender: null,
        line_id: null,
        profile_path: null,
        email: null,
        code: null,
      },
      detail: {},

      registerForm: null,
      jsonDefalut: {
        elements: [
          {
            name: "question1",
            type: "text",
            title: "ชื่อ",
            isRequired: true,
          },
          {
            name: "question2",
            type: "text",
            title: "นามสกุล",
            isRequired: true,
            startWithNewLine: false,
          },
          {
            name: "question3",
            type: "text",
            title: "เบอร์โทรศัพท์",
            isRequired: true,
            inputMask: "phone",
            inputFormat: "099-999-9999",
            maxLength: 10,
          },
        ],
        showQuestionNumbers: false,
      },
      statusText: "register",
      showScrollIcon: false,
    };
  },

  mounted() {
    this.onInit();
  },
  computed: {
    ...mapState("login", ["urlRedirect"]),
    ...mapState("friend", ["invite", "platform"]),
    ...mapState("defaultSystem", ["site", "userLine", "email"]),
    normalRules() {
      return [(v) => !!v || this.$t("validation.required")];
    },
  },
  watch: {},
  methods: {
    handleScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;

      const threshold = 30;
      const bottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

      this.showScrollIcon = !bottom;
    },
    scrollToBottom() {
      if (!this.$refs.scrollContainer) return;
      this.$refs.scrollContainer.scrollTo({
        top: this.$refs.scrollContainer.scrollHeight,
        behavior: "smooth",
      });
    },
    redirectHome() {
      return this.$router.push({
        name: "login-bypass",
      });
    },
    async onInit() {
      this.isAppLoading(true);
      this.$store.commit("defaultSystem/SET_USER", { role: "Customer" });
      this.getCondition();
      this.query_campaign_id = this.$route.query.campaign_id || null;
      if (this.query_campaign_id) {
        await this.getRegisterCampaign(this.query_campaign_id);
      }
      this.registerForm = this.site.schema_survey;
      if (this.registerForm != undefined) {
        if (typeof this.registerForm == "string") {
          this.registerForm = JSON.parse(this.registerForm);
        }
      }
      if (!this.registerForm) {
        this.registerForm = this.jsonDefalut;
      }
      let mobile = localStorage.getItem("mobile");
      if (mobile && this.registerForm) {
        let checkPhoneElement = this.registerForm.elements.find(
          (element) => element.name === "question3"
        );
        checkPhoneElement.defaultValue = mobile;
      }
      if (this.registerForm) {
        this.disableBtnRegister = false;
        this.registerForm.showCompletedPage = false;
        this.registerForm.checkErrorsMode = "onValueChanged";
        this.registerForm = this.setQuestionAddress(this.registerForm);
        this.registerForm = transformJsonCustomInputMask(this.registerForm);
        this.survey = new Model(this.registerForm);
      } else {
        this.disableBtnRegister = true;
      }
      // ========== ========== ========== ==========
      if (this.urlRedirect) {
        this.getMissionIdFromCampaign(this.urlRedirect);
      }

      if (this.survey) {
        this.survey.onComplete.add((sender, options) => {
          this.submitForm(sender, options);
        });
        this.survey.onValidateQuestion.add(this.checkRuleMobile);
        let _themeJson = { ...themeJson };
        if (this.site.theme) {
          _themeJson = { ...this.site.theme };
          if (!_themeJson.backgroundImage) {
            _themeJson.backgroundImage = "";
          }
        } else {
          this.survey.css = customCss;
          _themeJson.cssVariables["--sjs-primary-backcolor"] = this.site.color;
          _themeJson.cssVariables["--sjs-primary-backcolor-dark"] =
            this.site.color;
        }
        this.survey.applyTheme(_themeJson);
        this.uploadImage();
        this.onValueChanged();
        this.onAfterRenderPage();
        this.onAfterRenderQuestion();
      }
      // ========== ========== ========== ==========
      this.isAppLoading(false);
    },
    async getRegisterCampaign(id) {
      try {
        const response = await Axios.get(`getRegisterCampaign/${id}`);
        const dataResponse = response?.data;
        if (dataResponse?.status == "success" && dataResponse?.data) {
          const data = dataResponse.data;
          this.site.campaign_id = data.id;
          this.site.schema_survey = data.schema;
          this.site.theme = data.theme;
          if (data.is_member_use) {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("errDataNotFound"),
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.$router.push("/");
              });
          }
        }
      } catch (err) {
        console.log("getRegisterCampaign", err);
      }
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== ========== ==========
      });
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    async submitForm(sender, options) {
      this.isAppLoading(true);
      options.showSaveInProgress();
      this.detail = sender.data;
      this.campaign_id = this.site.campaign_id;
      this.detailUser.name = sender.data.question1;
      this.detailUser.surname = sender.data.question2;
      this.detailUser.phone = sender.data.question3;
      this.detailUser.birth_date = sender.data.birth_date || null;
      this.detailUser.gender = sender.data.gender || null;
      this.detailUser.email = sender.data.email || this.email || null;
      this.detailUser.code = sender.data.code || null;
      this.detailUser.line_id = this.userLine.userId ?? null;
      this.detailUser.profile_path = this.userLine.pictureUrl ?? null;
      let has_heic = false;
      let question_name_error = null;
      let upload_image_error = false;
      if (typeof sender.data == "object") {
        for (let key of Object.keys(sender.data)) {
          let question = sender.data[key];
          if (Array.isArray(question) && question.length > 0) {
            if (
              this.isImage(question[0].name) ||
              this.isVideo(question[0].name) ||
              this.isPDF(question[0].name) ||
              this.isSpreadsheet(question[0].name)
            ) {
              const imageFile = await this.convertBase64ToFile(
                question[0].content,
                question[0].name
              );
              const imageUrl = await this.uploadImageDefault(imageFile);
              if (!imageUrl) {
                upload_image_error = true;
                question_name_error = key;
                break;
              }
              question[0].content = imageUrl;
            } else if (this.isHeic(question[0].name)) {
              has_heic = true;
              question = null;
              question_name_error = key;
              break;
            }
          }
        }
      }
      if (has_heic) {
        options.showSaveError();
        sender.clear(false);
        if (question_name_error) {
          const targetQuestion = sender.getQuestionByName(question_name_error);
          if (targetQuestion) {
            targetQuestion.addError(this.$t("error.heicNotSupported"));
            targetQuestion.focus();
          }
        }
        this.isAppLoading(false);
        return;
      }
      if (upload_image_error) {
        options.showSaveError();
        sender.clear(false);
        if (question_name_error) {
          const targetQuestion = sender.getQuestionByName(question_name_error);
          if (targetQuestion) {
            targetQuestion.addError(this.$t("error.title"));
            targetQuestion.focus();
          }
        }
        this.isAppLoading(false);
        return;
      }
      if (this.site.is_login_bypass == "N") {
        this.sendOtpRegister();
      } else {
        this.register();
      }
      this.isAppLoading(false);
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },
    isHeic(link, mimeType = "") {
      const isExtensionHeic = /\.(heic|heif)$/i.test(link);
      const isMimeHeic = ["image/heic", "image/heif"].includes(
        mimeType.toLowerCase()
      );
      return isExtensionHeic || isMimeHeic;
    },
    getMissionIdFromCampaign(url) {
      this.mission_id = url.split("/")[2];
    },

    sendOtpRegister() {
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/sendOtpRegister?mobile=${this.detailUser.phone}`
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.request_id = res.data.data.request_id;
            this.ref_code = res.data.data.ref_code;
            this.$store.commit("login/SET_MOBILE", {
              mobile: this.detailUser.phone,
            });
            this.dialogOtp = true;
          } else if (res?.data?.status == "registered") {
            this.statusText = "login";
            this.sendOtp();
          } else {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("errRegistrationFailedContactAdmin"),
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.$router.push("/");
              });
          }
        })
        .catch((err) => {
          if (err?.response?.status === 400 || err?.response?.status === 500) {
            this.$swal.fire({
              icon: "error",
              text:
                err.response.data?.message ||
                this.$t("errRegistrationFailedContactAdmin"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push("/");
          } else {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("errRegistrationFailedContactAdmin"),
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.$router.push("/");
              });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    sendOtp() {
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/sendOtp?mobile=${this.detailUser.phone}`
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.request_id = res.data.data.request_id;
            this.ref_code = res.data.data.ref_code;
            this.$store.commit("login/SET_MOBILE", {
              mobile: this.detailUser.phone,
            });
            this.dialogOtp = true;
          }
        })
        .catch((err) => {
          if (err?.response?.status === 400 || err?.response?.status === 500) {
            this.$swal.fire({
              icon: "error",
              text:
                err.response.data?.message ||
                this.$t("errRegistrationFailedContactAdmin"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push("/");
          } else {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("errRegistrationFailedContactAdmin"),
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.$router.push("/");
              });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    sendOtpAgain() {
      if (this.statusText == "register") {
        this.sendOtpRegister();
      } else if (this.statusText == "login") {
        this.sendOtp();
      }
    },
    checkOTP(OTP) {
      this.loading = true;
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE + `/checkOtp`, {
          request_id: this.request_id,
          code: OTP,
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.dialogOtp = false;
            if (this.statusText == "register") {
              this.register();
            } else if (this.statusText == "login") {
              this.loginWithOutOtp();
            }
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          if (this.$refs.refVerifyOTP) {
            this.$refs.refVerifyOTP.clearOTP();
          }
          this.isAppLoading(false);
        });
      this.loading = false;
    },

    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },
    uploadImageDefault(file) {
      return new Promise((resolve) => {
        const formData = new FormData();
        formData.append("image", file);
        Axios.post("/uploadImageRegister", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data }) => {
            if (data.status == "success") {
              resolve(data.image_url);
            }
          })
          .catch(() => {
            resolve(null);
          });
      });
    },
    uploadImage() {
      this.survey.onUploadFiles.add(function (_, options) {
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);

          Axios.post("/uploadImageRegister", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                options.callback("success", [
                  {
                    file: file,
                    content: data.image_url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },

    checkRuleMobile(_, options) {
      if (options.question.name == "question3") {
        const phone = options.value;
        if (!/^(08|06|09)\d{8}$/.test(phone)) {
          options.error = this.$t("invalidPhoneNumber");
        }
      }
    },
    agreeCondition() {
      this.terms_of_service = true;
      this.dialogPDPA = false;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    saveDialogEditAddress() {
      if (!this.$refs.editForm.validate()) {
        return;
      }
    },

    async register() {
      this.isAppLoading(true);
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, this.detail);
      // ========== ========== ========== ==========
      Axios.post(`/registerUser`, {
        campaign_id: this.campaign_id,
        name: this.detailUser.name,
        surname: this.detailUser.surname,
        phone: this.detailUser.phone,
        birth_date: this.detailUser.birth_date,
        gender: this.detailUser.gender,
        email: this.detailUser.email ?? null,
        code: this.detailUser.code ?? null,
        line_id: this.detailUser.line_id ?? null,
        profile_path: this.detailUser.profile_path,

        platform: this.platform,
        invite: this.invite,
        detail: JSON.stringify(formatJson),
        mission_id: this.mission_id,
      })
        .then((res) => {
          if (res?.data?.status === "success") {
            this.$store.commit("login/SET_MOBILE", {
              mobile: this.detailUser.phone,
            });
            localStorage.setItem("token", res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                title: res.data.message,
                text: res.data.data.message,
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                this.isAppLoading(false);
                if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                }
                // ========== ========== Redirect & Reload ========== ==========
                const landing_page = getLandingPage();
                const targetRoute = this.$router.resolve({
                  name: landing_page,
                });
                window.location.href = targetRoute.href;
              });
          } else if (res?.data?.status === "registered") {
            this.statusText = "login";
            if (this.site?.is_login_bypass == "Y") {
              this.loginWithOutOtp();
            } else {
              this.sendOtp();
            }
          } else if (res?.data?.status === "pending") {
            this.$swal
              .fire({
                icon: "warning",
                text: res?.data?.message,
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.isAppLoading(false);
                this.redirectHome();
              });
          } else {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("errRegistrationFailedContactAdmin"),
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.isAppLoading(false);
                location.reload();
              });
          }
        })
        .catch((err) => {
          console.log("LoginWithOtpOption:RegisterPhone:register[err]", err);
          this.$swal
            .fire({
              icon: "error",
              text:
                err?.response?.data?.message ||
                this.$t("errRegistrationFailedContactAdmin"),
              showConfirmButton: false,
              timer: 2000,
            })
            .then(() => {
              this.isAppLoading(false);
              location.reload();
            });
        });
      this.survey.doComplete();
    },
    loginWithOutOtp() {
      this.loading = true;

      this.$store.commit("login/SET_MOBILE", { mobile: this.detailUser.phone });
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE + `/loginWithOutOtp`,
          {
            mobile: this.detailUser.phone,
          }
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$store.commit("defaultSystem/SET_USER", { role: "Customer" });
            this.setToken(res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                text: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                if (this.urlRedirect) {
                  this.$router.push({ path: this.urlRedirect });
                  return;
                }
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          } else {
            this.$swal
              .fire({
                icon: "info",
                html: res.data.message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonColor: this.site.color,
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.confirmLogin();
                }
              });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    confirmLogin() {
      this.loading = true;
      this.$store.commit("login/SET_MOBILE", { mobile: this.detailUser.phone });
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/confirmLoginWithOutOtp`,
          {
            mobile: this.detailUser.phone,
          }
        )
        .then((res) => {
          console.log("res :>> ", res);
          if (res?.data?.status === "success") {
            this.$store.commit("defaultSystem/SET_USER", { role: "Customer" });
            this.setToken(res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                if (this.urlRedirect) {
                  this.$router.push({ path: this.urlRedirect });
                  return;
                }
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          } else {
            this.$swal
              .fire({
                icon: "info",
                html: res.data.message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonColor: this.site.color,
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.confirmLogin();
                }
              });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    async setToken(accessToken) {
      return new Promise((resolve) => {
        localStorage.setItem("token", accessToken);
        resolve();
      });
    },
    redirectRegister() {
      if (this.terms_of_service == false) {
        this.$swal.fire({
          icon: "error",
          title: this.$t("pleaseAgreeTermAndCondition"),
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        this.survey.completeLastPage();
      }
    },
    getCondition() {
      Axios.get(`getCondition?site_id=${this.site.id}`)
        .then((res) => {
          if (res.data.status === "success") {
            this.condition = res.data.condition;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },

    formatCondition(param) {
      let html = param || "";
      if (html.includes("<iframe")) {
        html = html.replaceAll("<iframe", "<iframe style='max-width: 100%;'");
      }
      if (html.includes("<img")) {
        html = html.replaceAll(
          "<img",
          "<img style='max-width: 100%;width: auto !important;height: auto !important;'"
        );
      }
      return html;
    },
  },
};
</script>


<style scoped>
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
</style>

<style>
/* label.sd-file__choose-btn.sd-action.sd-file__choose-btn--text {
  background-color: white !important;
}

.input.th-address-input {
  border: #0017 !important;
}
.v-label.theme--light {
  color: white !important;
}
.sv-components-column .sd-action-bar #sv-nav-complete {
  display: none;
}
.svc-logic-question-value,
.sd-element--with-frame {
  background-color: transparent;
  -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.15);
}
.sd-page__row.sd-row--multiple:not(.sd-row--compact),
.svc-row > .sd-row--multiple {
  background-color: transparent;
  -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.15);
}
.sd-element__title span {
  color: white;
}
.sd-item__control-label {
  color: white;
}
.svc-logic-question-value,
.sd-element--with-frame {
  padding-top: 0 !important;
}
.sd-container-modern {
  margin-bottom: 0;
}
.sd-question__erbox--outside-question {
  background-color: red;
  color: white;
} */
</style>

<style scoped>
/* ในกรณีที่มี ปุ่ม Complete ทำให้ปุ่มยาวเต็มจอ */
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
</style>
